// Shared by the session check (ProtectedRoute) and the API hooks: what to do when the gateway says the sign-in is gone.

// The gateway's OAuth2 login entry point; Keycloak signs the user straight back in when its own session is still alive.
export const LOGIN_URL = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/oauth2/authorization/gateway-client`;

// How the session check treats a failed answer from /user. Anything the gateway sends back as 5xx, and "no answer at
// all", is retried after these pauses (so 3 tries in total) before the "can't reach the service" screen is shown.
// An object, not a constant, so a test can shorten the pauses.
export const sessionCheckSettings = {
  retryDelaysMs: [1000, 2000],
};

// One automatic trip to the login per window. If the user comes straight back and the gateway still answers 401,
// something other than an expired session is wrong, and sending them round again would loop forever.
const GUARD_KEY = 'napp.loginRedirectAt';
const GUARD_WINDOW_MS = 30000;

const readGuard = () => {
  try {
    return Number(window.sessionStorage.getItem(GUARD_KEY)) || 0;
  } catch (e) {
    return 0; // storage blocked: no guard, the redirect still works
  }
};

const writeGuard = (value) => {
  try {
    window.sessionStorage.setItem(GUARD_KEY, String(value));
  } catch (e) {
    // storage blocked: nothing to remember
  }
};

/**
 * Sends the browser to the login. Returns true if it did, false if it held back because it already did so a moment ago
 * (pass { force: true } for a click on "Log in again", which is the user's own decision).
 */
export function redirectToLogin({ force = false } = {}) {
  const now = Date.now();
  if (!force && now - readGuard() < GUARD_WINDOW_MS) {
    return false;
  }
  writeGuard(now);
  window.location.href = LOGIN_URL;
  return true;
}
